import { SubscriptionPlan } from '../types/subscriptionPlan';
import {
  barberStandardPriceId,
  barberStandardProductId,
  shopOwnerCrewPriceId,
  shopOwnerCrewProductId,
  shopOwnerSquadPriceId,
  shopOwnerSquadProductId,
  shopOwnerStandardPriceId,
  shopOwnerStandardProductId,
} from '../config';

export const INDEPENDENT_BARBER_PLANS: SubscriptionPlan[] = [
  {
    id: 'BARBER:Standard',
    name: 'Standard',
    subtitle: 'Pro Plan',
    price: 9.99,
    priceId: barberStandardPriceId,
    productId: barberStandardProductId,
    type: 'BARBER',
    trialDays: 90,
    tagColor: '#4caf50',
    marketingCampaignCount: 1,
    emailNotificationCount: 10,
    smsNotificationCount: 10,
    features: [
      'Personal appointment calendar',
      'Client management',
      'Service catalogue',
      'Schedule manager',
      'Reservation manager',
      'Email support',
    ],
  },
];

export const SHOP_OWNER_PLANS: SubscriptionPlan[] = [
  {
    id: 'SHOP_OWNER:Standard',
    name: 'Standard',
    subtitle: 'Shop Owner Standard',
    price: 14.99,
    priceId: shopOwnerStandardPriceId,
    productId: shopOwnerStandardProductId,
    barberSeatCount: 2,
    type: 'SHOP_OWNER',
    trialDays: 90,
    tagColor: '#4caf50',
    marketingCampaignCount: 1,
    emailNotificationCount: 10,
    smsNotificationCount: 10,
    features: [
      '2 barber seats',
      'Shop & team management',
      'Client management',
      'Personal appointment calendar',
      'Service catalogue',
      'Schedule manager',
      'Reservation manager',
      'Email support',
    ],
  },
  {
    id: 'SHOP_OWNER:Crew',
    name: 'Crew',
    subtitle: 'Shop Owner Crew',
    price: 24.99,
    priceId: shopOwnerCrewPriceId,
    productId: shopOwnerCrewProductId,
    barberSeatCount: 5,
    type: 'SHOP_OWNER',
    trialDays: 90,
    marketingCampaignCount: 5,
    emailNotificationCount: 25,
    smsNotificationCount: 25,
    features: ['5 barber seats', 'Everything in Standard', 'Priority support'],
  },
  {
    id: 'SHOP_OWNER:Squad',
    name: 'Squad',
    subtitle: 'Shop Owner Squad',
    price: 39.99,
    priceId: shopOwnerSquadPriceId,
    productId: shopOwnerSquadProductId,
    barberSeatCount: 10,
    type: 'SHOP_OWNER',
    trialDays: 90,
    marketingCampaignCount: 15,
    emailNotificationCount: 60,
    smsNotificationCount: 60,
    features: [
      '10 barber seats',
      'Everything in Crew',
      'Dedicated account manager',
    ],
  },
];
